/**
 * @generated SignedSource<<398375227cd4c923c49cb903c1494129>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type rulesPage_PresignQuery$variables = {
  fileExtension: string;
  nonce: string;
};
export type rulesPage_PresignQuery$data = {
  readonly uploadPresign: {
    readonly signedUrl: string;
    readonly storageKey: string;
  } | null | undefined;
};
export type rulesPage_PresignQuery = {
  response: rulesPage_PresignQuery$data;
  variables: rulesPage_PresignQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "fileExtension"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "nonce"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "fileExtension",
    "variableName": "fileExtension"
  },
  {
    "kind": "Variable",
    "name": "nonce",
    "variableName": "nonce"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "signedUrl",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "storageKey",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "rulesPage_PresignQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UploadPresign",
        "kind": "LinkedField",
        "name": "uploadPresign",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "rulesPage_PresignQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UploadPresign",
        "kind": "LinkedField",
        "name": "uploadPresign",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e0bacc55f09f897196a1b1f0989f04d4",
    "id": null,
    "metadata": {},
    "name": "rulesPage_PresignQuery",
    "operationKind": "query",
    "text": "query rulesPage_PresignQuery(\n  $fileExtension: String!\n  $nonce: String!\n) {\n  uploadPresign(fileExtension: $fileExtension, nonce: $nonce) {\n    signedUrl\n    storageKey\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "ab6991665433a3ef5bac59fa203ef633";

export default node;
